import { render } from "./Pray.vue?vue&type=template&id=07954bf8&scoped=true"
import script from "./Pray.vue?vue&type=script&lang=js"
export * from "./Pray.vue?vue&type=script&lang=js"

import "./Pray.vue?vue&type=style&index=0&id=07954bf8&scoped=true&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07954bf8"]])

export default __exports__